import { render, staticRenderFns } from "./BrainsWmsMap.vue?vue&type=template&id=a445bd8a&scoped=true&"
import script from "./BrainsWmsMap.vue?vue&type=script&lang=js&"
export * from "./BrainsWmsMap.vue?vue&type=script&lang=js&"
import style0 from "./BrainsWmsMap.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BrainsWmsMap.vue?vue&type=style&index=1&id=a445bd8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a445bd8a",
  null
  
)

export default component.exports